export const appDomain = process.env.VUE_APP_DOMAIN || "andsons.com.sg";
export const checkoutDomain =
  process.env.VUE_APP_CHECKOUT_DOMAIN || "http://localhost:8081";
export const intercomAppId = process.env.VUE_APP_INTERCOM_ID;
export const sentry = {
  dsn: process.env.VUE_APP_SENTRY_DSN,
};
